// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"2e51f5d8","788":"56c5785a","791":"439cf585"}[chunkId] + ".chunk.js";
};